import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };
  const SBLookup1 = {
    name: 'Secure Baseline Lookup',
    imageUrl: '../../images/SBLookup.png',
    imageSize: "100%",
    bradius: 20,
  };
  export const SBLookup = () => {
    return (
      <div style={helpcanvas}>
        <div
        style={{ marginLeft: "310px" }}
        ></div>
        <div style={helptitle}><b>Secure Baseline Lookup </b><br/><br/>
        The Secure Baseline Lookup feature allows you to look up details about what configuration recommendations are included within a benchmark for a particular OS.<br/><br/>
  
        Benchmarks from CISecurity or Defense Information Systems Agency (DISA) Security Technical Implementation Guides (STIG). For business/commercial use, CISecurity 
        benchmarks are used in almost all cases.  <br/><br/>
  
        Select the desired Benchmark source and the Operating system of interest. Then browse among the many configuration recommendations provided to see what is included in 
        the scans. <br/><br/>
  
        To drill down to get more information on the recommended configuration practice, click on a benchmark category or expand a row for more information. <br/><br/>
        </div>
        <div style={helpimg}>
        <img
          src={SBLookup1.imageUrl}
          alt={'Image of ' + SBLookup1.name}
          style={{
            width: SBLookup1.imageSize,
            borderRadius: SBLookup1.bradius,
          }}
        />
        </div>
      </div>
    );
  };
  